var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.display),expression:"display"}],staticClass:"loading_overlay_bg"},[_c('div',{staticClass:"ks_spinner_container"},[_c('p',{staticClass:"ks_sipnner_text"},[_vm._v(_vm._s(_vm.text))]),_c('i',{staticClass:"fa fa-spinner fa-spin fa-5x"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }